import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import RequestShippingQuoteBody from './RequestShippingQuoteBody';
import css from '../styles.scss';

export class RequestShippingQuoteModal extends Component {
    constructor(props) {
        super(props);

        this.handleClose = this.handleClose.bind(this);

        this.state = {
            isSubmitting: false,
        };
    }

    handleClose() {
        if (!this.state.isSubmitting) {
            this.props.closeShippingModal();
        }
    }

    render() {
        const { isSubmitting } = this.state;
        const {
            isOpened,
            onOpen,
            modalKey,
            userId,
            triggerUserRefetch,
            viewer,
            trackingLocation,
            submitTrackingLocation,
            onSuccess,
            onSuccessfulPreQuoteRequest,
            showAuthModal,
            openModal,
            showCompleteAccount,
            isMC,
            itemId,
            bulkItemIds,
            conversationIds,
            pageContext,
            currency,
            hasQuote,
            stepsWithForcedBackButton,
            onBackButtonClick,
            dealerPk,
            itemQuantity,
        } = this.props;
        return (
            <ModalContainer
                modalClass={css.sqrModalWrapper}
                isOpen={isOpened}
                onOpen={onOpen}
                onClose={this.handleClose}
                modalPosition="center"
                modalSize="medium"
            >
                <ModalCloseButton disabled={isSubmitting} onClick={this.handleClose} />
                <RequestShippingQuoteBody
                    onClose={this.handleClose}
                    modalKey={modalKey}
                    userId={userId}
                    triggerUserRefetch={triggerUserRefetch}
                    viewer={viewer}
                    trackingLocation={trackingLocation}
                    submitTrackingLocation={submitTrackingLocation}
                    onSuccess={onSuccess}
                    showAuthModal={showAuthModal}
                    openModal={openModal}
                    showCompleteAccount={showCompleteAccount}
                    isMC={isMC}
                    itemId={itemId}
                    bulkItemIds={bulkItemIds}
                    conversationIds={conversationIds}
                    pageContext={pageContext}
                    currency={currency}
                    hasQuote={hasQuote}
                    stepsWithForcedBackButton={stepsWithForcedBackButton}
                    onBackButtonClick={onBackButtonClick}
                    dealerPk={dealerPk}
                    onSuccessfulPreQuoteRequest={onSuccessfulPreQuoteRequest}
                    itemQuantity={itemQuantity}
                />
            </ModalContainer>
        );
    }
}

RequestShippingQuoteModal.propTypes = {
    isOpened: PropTypes.bool,
    onOpen: PropTypes.func,
    closeShippingModal: PropTypes.func,
    viewer: PropTypes.object,
    modalKey: PropTypes.string,
    userId: PropTypes.string,
    triggerUserRefetch: PropTypes.func,
    trackingLocation: PropTypes.string,
    submitTrackingLocation: PropTypes.string,
    onSuccess: PropTypes.func,
    showAuthModal: PropTypes.func,
    openModal: PropTypes.func,
    showCompleteAccount: PropTypes.func,
    isMC: PropTypes.bool,
    itemId: PropTypes.string,
    bulkItemIds: PropTypes.array,
    conversationIds: PropTypes.array,
    pageContext: PropTypes.string,
    currency: PropTypes.string,
    hasQuote: PropTypes.bool,
    stepsWithForcedBackButton: PropTypes.array,
    onBackButtonClick: PropTypes.func,
    dealerPk: PropTypes.string,
    onSuccessfulPreQuoteRequest: PropTypes.func,
    itemQuantity: PropTypes.number,
};

export default createFragmentContainer(RequestShippingQuoteModal, {
    viewer: graphql`
        fragment RequestShippingQuoteModal_viewer on Viewer {
            ...RequestShippingQuoteBody_viewer
        }
    `,
});
